export const setReport = (state, payload) => { state.report = payload };
export const setReportData = (state, payload) => { state.reportData = payload };
